import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const refundidSettings = defineIntegrationSettings({
  fields: { shopId: z.string().trim().min(1, "Shop ID is required") },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: { enabled: z.boolean() },
});
